skrilla.directive('players',function() {
    return {
        templateUrl: 'directives/players/players.html',
        scope: {
            sport: "=",
            onClick: "="
        },
        controller: function($scope, searchService, queryService, paginationService, cacheService){
            $scope.key =  $scope.sport + "Players";
            cacheService.registerObject("contestSport", $scope.sport);
            $scope.players = cacheService.getObjectOrElse($scope.key, []);

            $scope.reset = function(){
                $scope.query = {
                    sortBy: "name",
                    limit: 20
                };
            }
            $scope.reset()

            $scope.search = function () {
                paginationService.resetPage($scope.key);
                paginationService.pageQuery(getPlayers, $scope.key);
            }

            var getPlayers = function() {
                return searchService.get("players/" + queryService.getQueryString({...$scope.query, sport:$scope.sport}, $scope.key)).then(function (response) {
                    $scope.players = response.data.result;
                    cacheService.registerObject($scope.key, $scope.players);
                    paginationService.setPage($scope.key, paginationService.buildPage(response));
                });
            }

        }
    };
});
